module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "dialog-cancel-preorder",
    attrs: {
      "title": "取消预订单",
      "visible": _vm.visible,
      "before-close": _vm.exit
    }
  }, [_c('div', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "ui three fields"
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("定单人")]), _c('el-input', {
    attrs: {
      "disabled": "disabled"
    },
    model: {
      value: (_vm.preorder.customer_name),
      callback: function($$v) {
        _vm.$set(_vm.preorder, "customer_name", $$v)
      },
      expression: "preorder.customer_name"
    }
  })], 1), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("定单人电话")]), _c('el-input', {
    attrs: {
      "disabled": "disabled"
    },
    model: {
      value: (_vm.preorder.customer_phone),
      callback: function($$v) {
        _vm.$set(_vm.preorder, "customer_phone", $$v)
      },
      expression: "preorder.customer_phone"
    }
  })], 1), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("退回定金")]), _c('el-input', {
    attrs: {
      "disabled": "disabled"
    },
    model: {
      value: (_vm.preorder.earnest_money),
      callback: function($$v) {
        _vm.$set(_vm.preorder, "earnest_money", $$v)
      },
      expression: "preorder.earnest_money"
    }
  })], 1)]), _c('div', {
    staticClass: "ui two fields"
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("退回定金")]), _c('el-input-number', {
    attrs: {
      "controls": false
    },
    model: {
      value: (_vm.form.refund_money),
      callback: function($$v) {
        _vm.$set(_vm.form, "refund_money", $$v)
      },
      expression: "form.refund_money"
    }
  })], 1), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("退回定金")]), _c('payment-method-select', {
    model: {
      value: (_vm.form.refund_method),
      callback: function($$v) {
        _vm.$set(_vm.form, "refund_method", $$v)
      },
      expression: "form.refund_method"
    }
  })], 1)]), _c('div', {
    staticClass: "ui two fields"
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("退定原因")]), _c('el-autocomplete', {
    attrs: {
      "fetch-suggestions": _vm.reason_suggestions,
      "placeholder": "退定原因"
    },
    on: {
      "select": _vm.reason_select
    },
    model: {
      value: (_vm.form.cancel_reason),
      callback: function($$v) {
        _vm.$set(_vm.form, "cancel_reason", $$v)
      },
      expression: "form.cancel_reason"
    }
  })], 1), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("备注")]), _c('el-input', {
    model: {
      value: (_vm.form.note),
      callback: function($$v) {
        _vm.$set(_vm.form, "note", $$v)
      },
      expression: "form.note"
    }
  })], 1)]), _c('div', {
    staticClass: "actions"
  })]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "ui button themed",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确定取消预订单")]), _c('div', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        _vm.exit()
      }
    }
  }, [_vm._v("取消")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05f081f1","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/forms/DialogCancelPreorder.vue
// module id = 362
// module chunks = 0